/**
 * @author Rahul Nainala
 * @description 
 */
// import '../CSS/eLog.css';
import moment from 'moment';
import { Select, Button } from 'antd';
// import styles from '../CSS/style.less';
import React, { useEffect, useState } from 'react';
import TableViewInTable from './TableViewInTable';
import StyledTable from '../../../../commons/styles/table';

const { Option } = Select;

const TableInsideTables = (props) => {
  const generateColumns = (columns) => {
    let { translationCache } = props;
    let finalColumns = [];
    if (columns && columns.length > 0) {
      finalColumns = columns.map((column) => {
        return {
          ...column,
          title:
            translationCache && translationCache[column.title] && translationCache[column.title]
              ? translationCache[column.title]
              : column.title
        };
      });
    }
    return finalColumns;
  };
  const [editObj, setEditObj] = useState();
  const [form, setForm] = useState(props.form || {});
  const [columns, setColumns] = useState( props.form && props.form.columns
    ? generateColumns(props.form.columns)
    : []);
  const [data, setData] = useState(  props.form && props.form.datasource
    ? props.form.datasource.map((dataSource, index) => {
      return {
        ...dataSource,
        key: index + 1
      };
    })
    : []);
    // const [mainHeaderValue, setMainHeaderValue] = useState(props.mainHeaderValue ? props.mainHeaderValue : {});
    // const [subHeaderValue, setSubHeaderValue] = useState(props.subHeaderValue ? props.subHeaderValue : {});
    // const [open, setOpen] = useState(false);
    const [tableInTableStatus, setTableInTableStatus] = useState(false);

    useEffect(() => {
      setForm(props.form);
      setColumns(  props.form && props.form.columns
        ? generateColumns(props.form.columns)
        : []);
      setData(props.form && props.form.datasource
        ? props.form.datasource.map((dataSource, index) => {
          return {
            ...dataSource,
            key: index + 1
          };
        })
        : []);      
    },[props.form]);

    // const generateColumns = (columns) => {
    //   let { translationCache } = props;
    //   let finalColumns = [];
    //   if (columns && columns.length > 0) {
    //     finalColumns = columns.map((column) => {
    //       return {
    //         ...column,
    //         title:
    //           translationCache && translationCache[column.title] && translationCache[column.title]
    //             ? translationCache[column.title]
    //             : column.title
    //       };
    //     });
    //   }
    //   return finalColumns;
    // };

    const  addRow = () => {
      let { form } = props;
      let dataLength;
      dataLength = data.length + 1;
      let editObj = {
        key: dataLength,
        table: form.defaultTableInTable ? form.defaultTableInTable : {}
      };
      data.push(editObj);
      setTableInTableStatus(true); 
      setEditObj(editObj);
      let formObj = {
        ...form,
        datasource: [...(form['datasource'] ? form['datasource'] : []), editObj]
      };
      props.saveTableViewData(formObj);
    };


  const tableRowClick = (editObj) => {
    setTableInTableStatus(true);
    setEditObj(editObj);
  };

  const closeTable = () => {
    setTableInTableStatus(false);
    setEditObj({});
  };

  const _getJudgementData = (maxValue, datasource) => {
    switch (true) {
      case maxValue <= `${datasource['Excellent']}`: {
        return 'Excellent';
      }
      case maxValue <= `${datasource['Good']}`: {
        return 'Good';
      }
      case maxValue <= `${datasource['Possible']}`: {
        return 'Possible';
      }
      case maxValue >= `${datasource['Impossible']}`: {
        return 'Impossible';
      }
      default:
        return '';
    }
  };

  const saveTableViewData = async (tableIn, value, columnData, fieldvalue) => {
    let { form, formObject } = props;
    let table = {};
    let dataIndexKey = editObj && editObj.key ? editObj.key - 1 : 0;
    if (columnData && columnData.autopopulate && columnData.autopopulate === 'MAX') {
      let datasourceObject =
        formObject && formObject.form && formObject.form.datasource
          ? formObject.form.datasource
          : {};
      let getJudgementSymbol = _getJudgementData(fieldvalue, datasourceObject);
      table = {
        ...(form['datasource'] &&
          form['datasource'][dataIndexKey] &&
          form['datasource'][dataIndexKey]['table']
          ? form['datasource'][dataIndexKey]['table']
          : {}),
        Judgement: {
          ...(form['datasource'] &&
            form['datasource'][dataIndexKey] &&
            form['datasource'][dataIndexKey]['table'] &&
            form['datasource'][dataIndexKey]['table']['Judgement']
            ? form['datasource'][dataIndexKey]['table']['Judgement']
            : {}),
          datasource: [
            {
              ...(form['datasource'] &&
                form['datasource'][dataIndexKey] &&
                form['datasource'][dataIndexKey]['table'] &&
                form['datasource'][dataIndexKey]['table']['Judgement'] &&
                form['datasource'][dataIndexKey]['table']['Judgement'][0]
                ? form['datasource'][dataIndexKey]['table']['Judgement'][0]
                : {}),
              Judgement: getJudgementSymbol
            }
          ]
        },
        [tableIn]: {
          ...(form['datasource'] &&
            form['datasource'][dataIndexKey] &&
            form['datasource'][dataIndexKey]['table'] &&
            form['datasource'][dataIndexKey]['table'][tableIn]
            ? form['datasource'][dataIndexKey]['table'][tableIn]
            : {}),
          datasource: value
        }
      };
    } else {
      table = {
        ...(form['datasource'] &&
          form['datasource'][dataIndexKey] &&
          form['datasource'][dataIndexKey]['table']
          ? form['datasource'][dataIndexKey]['table']
          : {}),
        [tableIn]: {
          ...(form['datasource'] &&
            form['datasource'][dataIndexKey] &&
            form['datasource'][dataIndexKey]['table'] &&
            form['datasource'][dataIndexKey]['table'][tableIn]
            ? form['datasource'][dataIndexKey]['table'][tableIn]
            : {}),
          datasource: value
        }
      };
    }

    if (form && form['datasource'] && form['datasource'][dataIndexKey]) {
      form['datasource'][dataIndexKey] = {
        ...form['datasource'][dataIndexKey],
        table
      };
    }
    setEditObj({...editObj,
      table});
    props.saveTableViewData(form);
  };

  const yearSelect = (value) => {
    let datasourceList = form['datasource'];
    datasourceList[editObj.key - 1] = {
      ...datasourceList[editObj.key - 1],
      Year: value
    };
    let formObj = {
      ...form,
      datasource: datasourceList
    };
    setEditObj({
      ...editObj,
      Year: value
    });
    props.saveTableViewData(formObj);
  };

  let { loading, translationCache } = props;

  if (moment().year() > 2019) {
    var yearList = [];
    for (var i = 2017; i <= moment().year(); i++) {
      yearList.push(i);
    }
    yearList.sort((a, b) => b - a);
  }
  let tableInTableProcess = editObj && editObj.table ? editObj.table : {};

  let yearEntriedAlready =
    data &&
    Array.isArray(data) &&
    data.map((YearData) => {
      return YearData.Year;
    });

    return (
      <div 
      //className="tableView" 
      style={{ marginTop: '80px' }}>
        <div>
          <StyledTable size="small"
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={false}
            style={{ marginTop: '10px', border: '1px solid  red !important' }}
            rowClassName={(record) => (record.editable ? record.editable : '')}
            onRow={(record) => ({
              onClick: (e) => {
                e.stopPropagation();
                tableRowClick(record);
              }
            })}
          />
          {form && form.showAddButton ? (
            <Button type="primary" style={{ marginTop: '10px' }} onClick={addRow}>
              {translationCache && translationCache['Add Row'] && translationCache['Add Row']
                ? translationCache['Add Row']
                : 'Add Row'}
            </Button>
          ) : null}
        </div>

        {tableInTableStatus && tableInTableStatus === true ? (
          <div style={{ padding: '15px', border: '3px solid white', marginTop: '20px' }}>
            {tableInTableStatus && tableInTableStatus === true ? (
              <div>
                <Button style={{ float: 'right' }} onClick={closeTable}>
                  {' '}
                  Close
                </Button>

                <div style={{ marginTop: '10px' }}>
                  <label style={{ fontWeight: 'bold' }}>
                    {translationCache &&
                      translationCache['Select Year'] &&
                      translationCache['Select Year']
                      ? translationCache['Select Year']
                      : 'Select Year'}{' '}
                    :{' '}
                  </label>
                  <Select
                    value={editObj && editObj.Year ? editObj.Year : ''}
                    onChange={(e) => yearSelect(e)}
                    placeholder={'Select Year'}
                    style={{ width: '100px' }}
                  >
                    {yearList.map((value, index) => {
                      return (
                        <Option
                          key={index}
                          disabled={yearEntriedAlready.includes(value) ? true : false}
                          value={value}
                        >
                          {value}
                        </Option>
                      );
                    })}
                  </Select>
                </div>

                {tableInTableProcess &&
                  Object.keys(tableInTableProcess) &&
                  Object.keys(tableInTableProcess).map((tableIn, index) => {
                    return (
                      <TableViewInTable
                        key={index}
                        form={tableInTableProcess[tableIn]}
                        // formObject={props.formObject}
                        // recordType={'FormSubSectionTable'}
                        saveTableViewData={(e, columnsData, value) => {
                          saveTableViewData(tableIn, e, columnsData, value);
                        }}
                        translationCache={props.translationCache}
                      />
                    );
                  })}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
};

export default TableInsideTables;
